module.exports = __webpack_public_path__ + "static/img/csv.c0777cc4.png";